import {createStyles, Container, rem} from '@mantine/core';
import speaker from '../../assets/img/megaphone.png';

const useStyles = createStyles(theme => ({
  wrapper: {
    height: rem(600),
    position: 'relative',
    boxSizing: 'border-box',
    backgroundColor:
      theme.colorScheme === 'dark' ? theme.colors.dark[8] : '#21485e',
  },

  inner: {
    position: 'relative',
    paddingTop: rem(200),
    paddingBottom: rem(120),

    [theme.fn.smallerThan('sm')]: {
      paddingBottom: rem(80),
      paddingTop: rem(80),
    },
  },
}));

function TestimonialHero() {
  const {classes} = useStyles();

  return (
    <div className={classes.wrapper}>
      <Container size={1200} className={classes.inner}>
        <div className="text-center">
          <img src={speaker} width={300} alt="megaphone" />
        </div>
        <div>
          <h1 className="page-title top-a overlay2 overlay_1">Testimonials</h1>
        </div>
      </Container>
    </div>
  );
}

export default TestimonialHero;
